import { z } from 'zod';

import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { ObjectFit } from '../../types/ObjectFit';
import { WidgetType } from '../../utils/widgetsUtils';

// Re-exported for the widget schemas (Accordion/InteractivePoll/InteractiveQuiz) that import ObjectFit from
// here. Canonical definition lives in `common/types/ObjectFit` so answer images and the Image widget share one
// enum.
export { ObjectFit };

export enum AnswerStyleType {
  Default = 'Default',
  Button = 'Button',
  CheckboxWithoutBorder = 'CheckboxWithoutBorder'
}

const AnswerSchema = z.object({
  id: z.string(),
  text: z
    .object({
      /**
       * ProseMirror JSON
       */
      fragment: ProseMirrorJSONSchema
    })
    .optional(),
  image: z
    .object({
      src: z.string(),
      alt: z.string(),
      mobileSrc: z.string(),
      objectFit: z.nativeEnum(ObjectFit),
      mobileObjectFit: z.nativeEnum(ObjectFit),
      isDecorative: z.boolean().optional()
    })
    .optional(),
  audio: z
    .object({
      src: z.string(),
      title: z.string()
    })
    .optional(),
  video: z.object({}).optional()
});

export const SelectionQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.SelectionQuestion).extend({
  amountOfColumns: z.number(),
  answerElements: z.array(z.string()),
  answers: z.array(AnswerSchema),
  answersStyle: z.nativeEnum(AnswerStyleType),
  isSingleAnswerQuestion: z.boolean(),
  saveAnswers: z.boolean(),
  withRandomAnswers: z.boolean()
});

export type SelectionQuestionWidgetStaticSchema = z.infer<typeof SelectionQuestionWidgetStaticSchema>;
